import type { PortfolioData } from '../domain/portfolio.types';

function calculateDuration(dateStr: string) {
  const parts = dateStr.split('—').map(s => s.trim());
  if (parts.length < 2) return '';
  
  const start = new Date(parts[0]);
  const end = parts[1].toLowerCase() === 'present' ? new Date() : new Date(parts[1]);
  
  if (isNaN(start.getTime()) || isNaN(end.getTime())) return '';

  let years = end.getFullYear() - start.getFullYear();
  let months = end.getMonth() - start.getMonth();

  if (months < 0) {
    years--;
    months += 12;
  }
  
  // Inclusive of the starting month
  months++;
  if (months >= 12) {
    years++;
    months -= 12;
  }

  const res = [];
  if (years > 0) res.push(`${years}y`);
  if (months > 0) res.push(`${months}m`);
  
  return res.length > 0 ? res.join(' ') : '0m';
}

export function ExpEdu({ data }: { data: PortfolioData }) {
  return (
    <section className="section" id="exp">
      <div className="container">
        <div className="reveal" style={{ marginBottom: 64 }}>
          <div className="section-tag">03 · Experience & education</div>
          <h2 className="section-title">
            Four years of <span className="alt">production code</span>.
          </h2>
        </div>
        <div className="exp-edu-grid">
          <div className="reveal">
            <div className="about-card-title" style={{ marginBottom: 28 }}>// EXPERIENCE</div>
            <ol className="timeline">
              {data.experience.map((e, i) => (
                <li className={`timeline-item ${e.current ? 'current' : ''}`} key={i}>
                  <div className="timeline-date">
                    {e.date}
                    <span className="timeline-duration"> // {calculateDuration(e.date)}</span>
                  </div>
                  <h3 className="timeline-role">{e.role}</h3>
                  <div className="timeline-co">{e.co}<span className="sep">·</span><span className="timeline-loc">{e.location}</span></div>
                  <p className="timeline-desc">{e.desc}</p>
                </li>
              ))}
            </ol>
          </div>
          <div className="reveal">
            <div className="about-card-title" style={{ marginBottom: 28 }}>// EDUCATION</div>
            {data.education.map((e, i) => (
              <div className="edu-card" key={i}>
                <span className="yr">{e.yr}</span>
                <div className="deg">{e.deg}</div>
                <div className="school">{e.school}</div>
                <div className="note">{e.note}</div>
              </div>
            ))}
            <div className="edu-card" style={{ background: 'transparent', borderStyle: 'dashed' }}>
              <div className="deg" style={{ paddingRight: 0 }}>Always learning.</div>
              <div className="note">Currently exploring: Agentic workflows, RAG optimization patterns, and deep-diving into system design to build even more robust and scalable products.</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
